module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'job_manage'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('span', {
    staticClass: "header-tip"
  }, [_vm._v("Saturn Console")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('el-menu', {
    staticClass: "el-menu--dark el-menu--has-container",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "router": true
    }
  }, [_vm._l((_vm.serviceList), function(item) {
    return [(item.isSuper) ? _c('el-menu-item', {
      key: item.index,
      attrs: {
        "index": item.index,
        "route": item
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(_vm._s(item.title))]) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [(_vm.isShowHeaderSearch) ? _c('div', {
    staticClass: "headerbase-search"
  }, [_c('el-autocomplete', {
    attrs: {
      "prefix-icon": "el-icon-search",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入域名",
      "popper-class": "header-autocomplete"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.domainName),
      callback: function($$v) {
        _vm.domainName = $$v
      },
      expression: "domainName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4",
      "popper-append-to-body": false
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(_vm._s(_vm.userInfo.username || 'null'))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.handleEditPass
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("修改密码")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("注销")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "https://vipshop.github.io/Saturn/#/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v("帮助")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.handleVersion
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("关于")])])], 2)], 1)], 2)], 1), _vm._v(" "), (_vm.isEditUserPassVisible) ? _c('div', [_c('edit-pwd-dialog', {
    attrs: {
      "user-password-info": _vm.userPasswordInfo,
      "user-info-title": _vm.userInfoTitle,
      "user-info-operate": _vm.userInfoOperate
    },
    on: {
      "user-info-success": _vm.editUserPwdSuccess,
      "close-dialog": _vm.closeUserPwdDialog
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f65a7b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = 1377
// module chunks = 1